import { useState, useEffect } from 'react';
import firebaseService from '../services/firebase';

export const useShopData = () => {
  const [shopData, setShopData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = firebaseService.onShopDataChange((data) => {
      setShopData(data);
      setLoading(false);
      setError(null);
    });

    // Handle connection errors
    const errorTimeout = setTimeout(() => {
      if (loading) {
        setError('Failed to connect to server');
        setLoading(false);
      }
    }, 10000);

    return () => {
      unsubscribe();
      clearTimeout(errorTimeout);
    };
  }, [loading]);

  return { shopData, loading, error };
};